import { useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { IChangePasswordInput } from "models/auth";
import { useNotificationContext } from "contexts/NotificationContext";
import { useNavigate } from "react-router-dom";
import { RouteName } from "constants/route";
import { ERole } from "models/account";
import changePasswordValidator from "validators/changePassword.validator";
import { changePasswordApi } from "api/account";
import { getRole } from "helpers/privilege";

export default function useChangePassword() {
  const navigate = useNavigate();
  const { showError, showSuccess } = useNotificationContext();
  const [loading, setLoading] = useState<boolean>(false);
  const { control, handleSubmit } = useForm<IChangePasswordInput>({
    resolver: yupResolver(changePasswordValidator),
  });

  const accountDashboard = () => {
    const role = getRole();
    switch (role) {
      case ERole.ADMIN:
      case ERole.SUPER_ADMIN:
      case ERole.DISPATCH:
        return RouteName.DASHBOARD;
      case ERole.CASHER:
        return RouteName.DRIVER;
      case ERole.POLICE:
        return RouteName.DRIVER_SEARCH;
      default:
        return RouteName.TRIP;
    }
  };

  const onSubmit = async (input: IChangePasswordInput) => {
    setLoading(true);
    const { data, error } = await changePasswordApi(input);
    if (data) {
      showSuccess("Successfully password changed");
      navigate(accountDashboard(), { replace: true });
    } else {
      showError(error!.message);
    }
    setLoading(false);
  };

  return { handleSubmit, onSubmit, control, loading };
}
